import { DateTime } from 'luxon'
import React, { useContext, useEffect, useState } from 'react'
import { Controller, FieldValues, FormProvider, useForm } from 'react-hook-form'
import { AppContext } from '../../context/AppContext'
import Modal from './Modal'
import { DateValidationError } from '@mui/x-date-pickers'

import { WorkoutShortcut } from '../../types/workouts'
import toast from 'react-hot-toast'
import { useWorkoutPublisher } from '../../hooks/useWorkoutPublisher'
import { Analytics } from '../../services/analytics'
import DatePicker from '../inputs/DatePicker/DatePicker'

type Props = {
  isVisible: boolean
  isLoading?: boolean
  onCancel: () => void
  onConfirm: () => void
  workoutShortcut: WorkoutShortcut | null
}

const AddWorkoutToCalendar = ({
  isVisible,
  onCancel,
  onConfirm,
  workoutShortcut,
}: Props) => {
  const { currentSpace } = useContext(AppContext)

  const formMethods = useForm<{ date: DateTime }>({
    defaultValues: { date: DateTime.now() }, // MUI datepicker requires a dayjs object
    shouldUnregister: true,
  })

  const [data, setData] = useState(workoutShortcut)

  useEffect(() => {
    if (workoutShortcut) setData(workoutShortcut)
  }, [workoutShortcut])

  const save = async ({ date }: any) => {
    Analytics._logEvent({
      name: 'add_benchmark_workout',
      params: {
        via: 'playbook',
      },
    })
    await addPredefinedWorkout({
      workoutShortcut: data,
      eventDateISO: date.toISODate(),
      index: 0,
    })
    toast.success('Workout added to calendar')
    onConfirm()
  }

  const { addPredefinedWorkout } = useWorkoutPublisher()

  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    formMethods.setFocus('date')
  }, [isVisible])

  // const [pickerOpen, setPickerOpen] = useState(false)

  // const handleDatePickerError = (reason: DateValidationError) => {
  //   switch (reason) {
  //     case 'invalidDate':
  //       setError('Invalid date')
  //       break
  //     case 'minDate':
  //       setError('Date is too far in the past')
  //       break
  //     case 'maxDate':
  //       setError('Date is too far in the future')
  //       break

  //     case null:
  //       setError(null)
  //   }
  // }

  return (
    <Modal
      isVisible={isVisible}
      onCancel={() => {
        formMethods.reset()
        onCancel()
      }}
      size="small"
      secondaryTitle={data?.title ? 'Add Workout to Calendar' : ''}
      title={data?.title ? data.title : 'Add Workout to Calendar'}
      buttons={{
        secondary: {
          onClick: () => {
            setError(null)
            formMethods.reset()
            onCancel()
          },
        },
        primary: {
          onClick: formMethods.handleSubmit(save),
          label: 'Add',
          isSubmitButton: true,
          disabled: error ? true : false,
        },
      }}
    >
      <FormProvider {...formMethods}>
        <DatePicker name="date" label="Select Date" />
      </FormProvider>

      {/* <Controller
        name="date"
        control={control}
        render={({ field: { ref, ...fieldProps } }) => (
          <DatePicker
            className={error ? 'error' : ''}
            open={pickerOpen}
            onClose={() => setPickerOpen(false)}
            minDate={DateTime.now().minus({ month: 6 }).toISODate()}
            maxDate={DateTime.now().plus({ year: 1 }).toISODate()}
            onError={handleDatePickerError}
            value={fieldProps.value.t}
            slotProps={{
              actionBar: {
                actions: ['today'],
              },
              textField: {
                className: 'date-picker',
                autoComplete: 'off',
                type: 'text',
                onClick: () => setPickerOpen(true),
              },
            }}
            sx={{ width: '100%', marginBottom: '8px' }}
            {...fieldProps}
          />
        )}
      /> */}

      {error && (
        <p
          style={{
            color: 'var(--accent-red)',
            marginTop: '-6px',
            font: 'var(--small-text)',
          }}
        >
          {error}
        </p>
      )}
    </Modal>
  )
}

export default AddWorkoutToCalendar
